/**
 * 料金ページの?マークをクリックしたときにヘルプを表示するクラス
 */
export default class PricePlanHelp {
  constructor() {
    /**
     * ヘルプを表示するブロックのclass名
     * @type {String}
     */
    this.blockElement = '.js-price-plan-help';
    /**
     * ？マークのclass名
     * @type {String}
     */
    this.iconElement = '.js-price-plan-help-icon';
    /**
     * ヘルプ内容のclass名
     * @type {String}
     */
    this.contentElement = '.js-price-plan-help-content';
    this.init();
  }

  init() {
    const $targets = document.querySelectorAll(this.blockElement);
    Array.from($targets).forEach(($target) => {
      const $icon = $target.querySelector(this.iconElement);
      const $content = $target.querySelector(this.contentElement);
      if (!$icon || !$content) {
        return;
      }
      $icon.addEventListener('click', () => {
        if ($content.hasAttribute('aria-expand')) {
          $content.style.height = '0';
          $content.removeAttribute('aria-expand');
        } else {
          $content.style.height = `${$content.scrollHeight + 10}px`;
          $content.setAttribute('aria-expand', '');
        }
      });
    });
  }
}
